/* global axios */

import ApiClient from './ApiClient';

class TaccAsanaAPI extends ApiClient {
  constructor() {
    super('tacc_asana', { accountScoped: true });
  }

  getWorkspaces() {
    return axios.get(`${this.url}/workspaces`);
  }

  getProjects(workspaceGid) {
    return axios.get(`${this.url}/projects`, {
      params: { workspace_gid: workspaceGid },
    });
  }

  getTasks(projectGid) {
    return axios.get(`${this.url}/tasks`, {
      params: { project_gid: projectGid },
    });
  }

  getUsers(workspaceGid, projectGid) {
    return axios.get(`${this.url}/users`, {
      params: { workspace_gid: workspaceGid, project_gid: projectGid },
    });
  }

  taskUrl(conversationId) {
    return `${this.baseUrl()}/conversations/${conversationId}/tacc_asana_task`;
  }

  taskLinkUrl(conversationId, taskLinkId) {
    return `${this.taskUrl(conversationId)}/${taskLinkId}`;
  }

  getLinkedTask(conversationId) {
    return axios.get(this.taskUrl(conversationId));
  }

  createTask(conversationId, task) {
    return axios.post(this.taskUrl(conversationId), { task });
  }

  updateTask(conversationId, taskLinkId, task) {
    return axios.patch(this.taskLinkUrl(conversationId, taskLinkId), { task });
  }

  unlinkTask(conversationId, taskLinkId, deleteAsana = false) {
    return axios.delete(this.taskLinkUrl(conversationId, taskLinkId), {
      data: { delete_asana: deleteAsana },
    });
  }
}

export default new TaccAsanaAPI();
